module.exports = __webpack_public_path__ + "static/media/envelop.10100e62.svg";